import {
	AccountCircleRounded,
	AddCircleRounded,
	AdminPanelSettingsRounded,
	AppSettingsAltRounded,
	AssignmentRounded,
	BadgeRounded,
	CancelRounded,
	CategoryRounded,
	CheckCircleRounded,
	CloseRounded,
	CollectionsBookmarkRounded,
	DeleteRounded,
	EditRounded,
	EmailRounded,
	ExpandMoreRounded,
	FileCopyRounded,
	GavelRounded,
	HomeRounded,
	HomeWorkRounded,
	InfoRounded,
	LayersRounded,
	NoteAltRounded,
	PendingRounded,
	PeopleAltRounded,
	PrivacyTipRounded,
	QuizRounded,
	ReportProblemRounded,
	SaveRounded,
	SchoolRounded,
	SearchRounded,
	VisibilityRounded,
} from "@mui/icons-material";

const ENTITIES_ICONS = {
	HOME: HomeRounded,
	GLOSSARY: CollectionsBookmarkRounded,
	PRINCIPLES: SchoolRounded,
	AIA: AssignmentRounded,
	EPS: NoteAltRounded,
	USERS: PeopleAltRounded,
	ORGANIZATION: HomeWorkRounded,
	APPLICATION: AppSettingsAltRounded,
	QUESTIONNAIRES: FileCopyRounded,
	AREAS: CategoryRounded,
	SECTIONS: LayersRounded,
	QUESTIONS: QuizRounded,
	TERMS_AND_CONDITIONS: GavelRounded,
	PRIVACY_POLITICS: PrivacyTipRounded,
	ADMIN: AdminPanelSettingsRounded,
};

const ACTIONS_ICONS = {
	VIEW: VisibilityRounded,
	EDIT: EditRounded,
	DELETE: DeleteRounded,
	CLOSE: CloseRounded,
	ADD: AddCircleRounded,
	SAVE: SaveRounded,
	SEARCH: SearchRounded,
	EXPAND_DOWN: ExpandMoreRounded,
};

const FEEDBACKS_ICONS = {
	PENDING: PendingRounded,
	SUCCESS: CheckCircleRounded,
	WARNING: ReportProblemRounded,
	INFO: InfoRounded,
	ERROR: CancelRounded,
};

const USER_ICONS = {
	FULLNAME: AccountCircleRounded,
	NAME: AccountCircleRounded,
	SURNAME: PeopleAltRounded,
	EMAIL: EmailRounded,
	ATTRIBUTIONS: BadgeRounded,
};

export const PROJECT_ICONS = {
	ENTITY: ENTITIES_ICONS,
	ACTION: ACTIONS_ICONS,
	FEEDBACK: FEEDBACKS_ICONS,
	USER: USER_ICONS,
};
